import { defineComponent as s, createElementBlock as n, openBlock as l, Fragment as o, renderList as t, normalizeClass as a } from "vue";
const m = /* @__PURE__ */ s({
  __name: "LoadingSkeleton",
  props: {
    lines: { default: 1 }
  },
  setup(i) {
    return (e, p) => (l(!0), n(o, null, t([...Array(e.lines).keys()], (r) => (l(), n("div", {
      key: r,
      class: a(["loading", { "single-line": e.lines === 1 }])
    }, null, 2))), 128));
  }
});
export {
  m as default
};
